import React, { useState, useContext, useMemo } from 'react'
import { Button, Checkbox, DatePicker, message } from 'antd'
import { getApiTargetInfo, hasAccesPermits, UnitSelection } from 'core'
import { connect } from 'react-redux'
import {
  UnitSelectionContext,
  DatePickerContext,
  ErrorContext,
  SpinContext,
} from 'context'
import { hydroProcess } from 'api/pgads'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUnits,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import { JcTmpErrorTable } from 'core/component/JcTmpErrorDialog'
import {
  NON_HYDRO_ALL_UNITS,
  RENAME_HYDRO_TO_BREAKER_EVENT,
} from 'core/EventActions'

const ProcessHydroScreen = ({
  apiTargetInfo,
  units,
  actionPermits,
  envConfig,
}) => {
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState([])
  const [reset, setReset] = useState(0)

  const processTask = _ => {
    if (selectedUnits.length < 1) {
      message.error('Please,Select Unit(s)')
      setVisibleUnitSelection(true)
    }
    setSpinning(true)
    hydroProcess(apiTargetInfo)({
      units: selectedUnits.map(u => u.unitId),
      reset,
      startDate: selectedDate
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: selectedDate
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD'),
    }).fork(setError, d => {
      setSpinning(false)
      setData(d)
    })
  }

  const nonHydroAllUnits = hasAccesPermits({
    actionPermits,
    eventActions: [NON_HYDRO_ALL_UNITS],
    matchAny: true,
  })

  const renameHydroToBreakerEvent = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [RENAME_HYDRO_TO_BREAKER_EVENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  return (
    <div
      style={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <UnitSelection
        setData={() => setData([])}
        limitedUnits={units.filter(
          un => nonHydroAllUnits || un.id1 === 'HD' || un.id1 === 'PS'
        )}
      />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          {renameHydroToBreakerEvent
            ? 'Process Breaker Events'
            : 'Process Hydro Events'}
        </Title>

        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />
        <Checkbox
          style={{ marginLeft: '15px' }}
          checked={reset === 1}
          onChange={e => setReset(e.target.checked ? 1 : 0)}
        >
          Reset and Delete All Data{' '}
        </Checkbox>
        <Button
          loading={spinning}
          onClick={processTask}
          style={{ marginLeft: '10px' }}
          type="danger"
          icon="thunderbolt"
        >
          Process
        </Button>
      </CriteriaRow>
      <FullHeightSizer heightOffset={300}>
        {({ height, _ }) => (
          <Content style={{ height: height - 20, paddingTop: '0px' }}>
            <div
              style={{ display: 'grid', height: height - 100, padding: '20px' }}
            >
              <JcTmpErrorTable errors={data || []} />
            </div>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ProcessHydroScreen)
